<pos-table [data]="this.recollectionList" [headers]="this.getRecollectionHeaders()" (dataChange)="getRecollections($event)" [pagination]="true" [itemsPerPage]="10" ></pos-table>
